export default {
  mainPage: 'Homepage',
  additionalInformationAdded: 'Zusätzliche Informationen hinzugefügt',
  assignOrSelectTheNameFromTheList: 'Zuweisen oder Auswählen des Namens aus der Liste',
  AddPeopleToAnExistingList: 'Hinzufügen von Personen zu einer vorhandenen Liste',
  updateList: 'Aktualisierungsliste',
  eventModified: 'Geändertes Ereignis',
  completeTheRequiredFields: 'Füllen Sie die erforderlichen Felder aus',
  anErrorHasOcurred: 'Ein Fehler ist aufgetreten',
  insertKeybeUiOnYourWebsite: 'Einfügen der Keybe-Benutzeroberfläche in Ihre Website',
  toInsertKeybeUiIntoYourWebsiteYouMustCreateADivElementWithTheIdKeybe: ' Um KeybeUI in Ihre Website einzubetten, müssen Sie ein DIV-Element mit der ',
  andThenAddTheFollowingScriptInTheFooterOfYourSite: 'Und fügen Sie dann das folgende Skript in der Fußzeile Ihrer Website hinzu.',
  toAddElementsInTheDOMToOpenTheKeybeUIYouCanUseAScriptSimilarToTheFollowing: 'Um Elemente im DOM hinzuzufügen, mit denen Sie keybeUI öffnen können, können Sie ein Skript ähnlich dem folgenden verwenden:',
  selectProfilePhoto: 'Profilbild auswählen',
  selectPhoto: 'Foto auswählen',
  photoSuccessfullyUpdated: 'Foto korrekt aktualisiert',
  select: 'Auswählen'
}
